import React from "react";

import { Box, Chip, Grid, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles(theme => ({
  summary: {
    marginBottom: theme.spacing(2),
  },
  avatar: {
    marginRight: theme.spacing(1),
  },
  districtChip: {
    marginRight: theme.spacing(2),
  },
  chipSkeleton: {
    backgroundColor: theme.palette.grey[200],
    height: 20,
    width: 40,
  },
}));

const DistrictCoverageSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item container md={2} xs={12} alignItems="center">
        <Box display="flex" alignItems="center">
          <Skeleton
            variant="circle"
            width={40}
            height={40}
            className={classes.avatar}
          />
          <Skeleton width={100} height={30} />
        </Box>
      </Grid>
      <Grid item container md={10} xs={12} alignItems="center">
        <Box mr={20}>
          <Skeleton width={250} height={30} />
        </Box>
        <Chip
          className={classes.districtChip}
          label={<Skeleton className={classes.chipSkeleton} />}
        />
        <Chip
          className={classes.districtChip}
          label={<Skeleton className={classes.chipSkeleton} />}
        />
        <Chip
          className={classes.districtChip}
          label={<Skeleton className={classes.chipSkeleton} />}
        />
        <Chip
          className={classes.districtChip}
          label={<Skeleton className={classes.chipSkeleton} />}
        />
        <Chip
          className={classes.districtChip}
          label={<Skeleton className={classes.chipSkeleton} />}
        />
      </Grid>
    </Grid>
  );
};

export default DistrictCoverageSkeleton;
